import React from 'react'
import { useTranslation } from 'react-i18next'
import { TransitOperationFormValues } from 'features/declaration/models/schemas/transitOperationFormSchema'
import useCodelist from 'features/declaration/codelist/api/useCodelist'
import E1114Validator from 'features/declaration/form/validations/E1114'
import FormCollapsibleColumn from 'components/p5/FormCollapsibleColumn'
import FormField from 'components/p5/FormField'
import FormSelect from 'components/p5/FormSelect'
import Input from 'components/p5/Input'
import useDeclarationFieldRequirements
  from 'features/declaration/form/components/useDeclarationFieldRequirements'

const scope = 'placeOfLoading'

function PlaceOfLoading() {
  const { t } = useTranslation()
  const [, countriesOptions] = useCodelist('COUNTRIES')

  const fieldRequirements = useDeclarationFieldRequirements<TransitOperationFormValues>('transitOperation', [
    scope,
    'placeOfLoading.country',
    'placeOfLoading.location',
  ])

  return (
    <section className="py-3">
      <FormCollapsibleColumn
        columnId="declaration-loading-place"
        headingLabel={t('declaration.p5.placeOfLoading')}
        fieldRule={fieldRequirements[scope]}
      >
        <FormField
          labelKey="declaration.p5.nationality"
          fieldRule={fieldRequirements['placeOfLoading.location']}
        >
          <FormSelect
            <TransitOperationFormValues>
            field="placeOfLoading.country"
            labelKey="declaration.p5.nationality"
            options={countriesOptions}
            type="sync"
            fieldRule={fieldRequirements['placeOfLoading.country']}
          />
        </FormField>
        <FormField
          labelKey="declaration.p5.placeOfLoadingLocation"
          fieldRule={fieldRequirements['placeOfLoading.location']}
        >
          <Input
            <TransitOperationFormValues>
            field="placeOfLoading.location"
            labelKey="declaration.p5.placeOfLoadingLocation"
            type="text"
            maxLength={E1114Validator.getMaximumLengthOfLoadingLocation()}
            placeholder={t('declaration.p5.placeOfLoadingLocation')}
            fieldRule={fieldRequirements['placeOfLoading.location']}
          />
        </FormField>
      </FormCollapsibleColumn>
    </section>
  )
}

export default PlaceOfLoading
